import { usePopup } from '@contexts/popupContext';
import { apiConfig, APIIntegration } from '@integrations/APIIntegration';
import styles from '@styles/components/QontactPoints/Turnos/QontactPointTurnos.module.css';
import { useEffect, useState } from 'react';
import { Loader } from '@shared/designSystem/Loader';

import { ReactComponent as QontactPointSVG } from '@assets/SVGs/QontactPoint/QontactPointSVG.svg';
import { ReactComponent as WarningSVG } from '@assets/SVGs/QontactPoint/WarningSVG.svg';
import { v4 as uuid } from "uuid";

import QPTurno from './QPTurno';
import { Application } from '@core/Application';

const QontactPointTurnos = ({orgID, qontactPoint}) => {
    const { showPopup, hidePopup } = usePopup()
    const [loading, setLoading] = useState(false)

    const [turnos, setTurnos] = useState([])
    const [error, setError] = useState("")

    useEffect(() => {console.log(qontactPoint)}, [qontactPoint])

    useEffect(() => {
        if (qontactPoint.shifts) {
            const days = ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado']

            let daysArray = Object.keys(qontactPoint.shifts)
            let finalShifts = []

            daysArray.map((dayIndex) => {

                let dayShifts = qontactPoint.shifts[dayIndex]

                for (let shiftIndex in dayShifts) {
                    let existingShift = finalShifts.find(shift => shift.name === dayShifts[shiftIndex].name)

                    if (!existingShift) {

                        let unique_id = uuid().slice(0, 8);

                        finalShifts.push({
                            id: unique_id,
                            ids: [dayShifts[shiftIndex].id],
                            name: dayShifts[shiftIndex].name,
                            hourFrom: dayShifts[shiftIndex].hourFrom,
                            hourTo: dayShifts[shiftIndex].hourTo,
                            expected: dayShifts[shiftIndex].expected,
                            tolerance: dayShifts[shiftIndex].tolerance,
                            days: [days[dayIndex]]
                        })
                    } else {
                        existingShift.ids.push(dayShifts[shiftIndex].id)
                        existingShift.days.push(days[dayIndex])
                    }
                }
            })
            console.log(finalShifts)
            setTurnos(finalShifts)
        }

    }, [qontactPoint])


    useEffect(() => {
        let duplicateName = false
        for (let turno of turnos) {
            for (let turno2 of turnos) {
                if (turno2.name.trim() === turno.name.trim()) {
                    if (turno2.id !== turno.id) {
                        duplicateName = true
                    }
                }
            }
        }

        if (duplicateName) {
            setError("No puedes tener dos turnos con el mismo nombre.")
        } else {
            if (error === "No puedes tener dos turnos con el mismo nombre.") {
                setError("")
            }
        }
    }, [turnos])

    function normalizeTime(time) {
        const [hour, minute] = time.split(":");
        const normalizedHour = parseInt(hour, 10).toString();
        return `${normalizedHour}:${minute}`;
    }

    const handleValidation = () => {
        for (let turno of turnos) {
            for (let turno2 of turnos) {
                if (turno2.name.trim() === turno.name.trim()) {
                    if (turno2.id !== turno.id) {
                        setError("No puedes tener dos turnos con el mismo nombre.")
                        return false
                    }
                }
            }
        }

        for (let turno of turnos) {
            if (turno.name.trim() === '' || turno.hourFrom.trim() === '' || turno.hourTo.trim() === '' || turno.days.length === 0) {
                setError("No pueden haber campos vacios.")
                return false
            }
        }


        for (let turno of turnos) {
            for (let turno2 of turnos) {
                if (turno.id === turno2.id) continue

                if (normalizeTime(turno.hourFrom) === normalizeTime(turno2.hourFrom)) {
                    for (let day of turno.days) {
                        if (turno2.days.includes(day)) {
                            console.log(turno, turno2, day)
                            setError("No es posible crear dos turnos para el mismo día con el mismo horario de inicio. Por favor, verificá la información.")
                            return false
                        }
                    }
                }
            }
        }

        setError("")
        return true
    }

    const handleSave = async () => {
        if (!handleValidation()) return

        const data = turnos.map((turno) => {
            turno.hourFrom = normalizeTime(turno.hourFrom)
            turno.hourTo = normalizeTime(turno.hourTo)
            return turno
        });
        console.log(data)
        
        setLoading(true)
        try {
            const shiftService = Application.shared().coreDependencies.shiftsService;
            const buildingID = qontactPoint.buildingID ? qontactPoint.buildingID : qontactPoint.buildingId;
            await shiftService.updateV1ShiftConfiguration(orgID, buildingID, data);
        } catch (error) {
            console.error(error)
        }
        setLoading(false)
    }

    return (
        <div className={styles['main-container']}>
            <div className={styles['nomina-header']}>
                <div className={styles['svg-container']} style={{marginRight: '8px', marginLeft: '15px'}}>
                    <QontactPointSVG/>
                </div>
                <h2 className={styles['title-nomina']}>
                    Turnos para {qontactPoint ? qontactPoint.name : 'Qontact Poin'}
                </h2>
            </div>

            <div className={styles['listado-container']}>
                {!loading ? 
                    turnos.length > 0 ? 
                    turnos.map((turno, index) => {
                        return (
                            <QPTurno key={turno.id} turno={turno} setTurnos={setTurnos}/>
                        )
                    })
                    :
                    <div className={styles['no-qontact-points']}>
                        <p>No tienes turnos configurados aun!</p>
                    </div>
                :
                <div className={styles['no-qontact-points']}>
                    <Loader height="48px" width="48px" />
                </div>
                }
            </div>

            {error && 
            <div className={styles['error-container']}>
                <div className={styles['svg-container']} style={{marginRight: '15px'}}>
                    <WarningSVG/>
                </div>
                {error}
            </div>
            }

            <div className={styles['bottom-container']}>
                    <div className={styles['add-buttons-container']}>
                        <div className={`${styles['button']} ${styles['agregar']}`} onClick={() => {
                            console.log('agregar turno')
                            setTurnos((prev) => {
                                let unique_id = uuid().slice(0, 8);

                                return [...prev, 
                                {
                                    id: unique_id,
                                    ids: [unique_id],
                                    name: '',
                                    hourFrom: '',
                                    hourTo: '',
                                    expected: 0,
                                    tolerance: 0.1,
                                    days: []
                                }]
                            })
                        }}>
                            + Agregar Turno
                        </div>
                    </div>


                    <div className={styles['buttons-container']}>
                        <div className={`${styles['button']} ${styles['guardar']}`} onClick={handleSave}>
                            {!loading ? 'Guardar'
                            :
                            <div className={styles['no-qontact-points']}>
                                <Loader height="32px" width="32px" />
                            </div>
                            }
                        </div>
                        <div className={`${styles['button']} ${styles['cancelar']}`}>
                            Cancelar
                        </div>
                    </div>
                </div>
        </div>
    )
}

export default QontactPointTurnos
